export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./mpesa.vue?vue&type=template&id=4cd8e435"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/mpesa.vue?vue&type=template&id=4cd8e435
// module id = wTEs
// module chunks = 0